import { ISinhVienDangKyThucTapViewModel } from "../../../model/response/xet-thuc-tap/ISinhVienDangKyThucTapViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eSinhVienDangKyThucTapActionsObj = {
    LOAD_BY_DOT_THUC_TAP_START: 0,
    LOAD_BY_DOT_THUC_TAP_SUCCESS: [] as ISinhVienDangKyThucTapViewModel[], // Replace 'any' with the actual type if available
    LOAD_BY_DOT_THUC_TAP_ERROR: "",
}

export const eSinhVienDangKyThucTapActionIds = generateActionTypeIds(eSinhVienDangKyThucTapActionsObj, "SINH_VIEN_DANG_KY_THUC_TAP");
export type ISinhVienDangKyThucTapActionType = IGenericActionType<typeof eSinhVienDangKyThucTapActionsObj, "SINH_VIEN_DANG_KY_THUC_TAP">;